import { render, staticRenderFns } from "./selfHelp.vue?vue&type=template&id=15dc77f8&scoped=true&"
import script from "./selfHelp.vue?vue&type=script&lang=js&"
export * from "./selfHelp.vue?vue&type=script&lang=js&"
import style0 from "./selfHelp.vue?vue&type=style&index=0&id=15dc77f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dc77f8",
  null
  
)

export default component.exports